/* ═══════════════════════════════════════════════
   ARSHE PERFUMES — LUXE JAVASCRIPT (COMPLETE)
   Cinematic Preloader + All Features
   ═══════════════════════════════════════════════ */

(function() {
  'use strict';

     // ═══ 🎬 PRELOADER — SMART POSITION MATCHING ═══
  function initPreloader() {
    var preloader = document.getElementById('luxePreloader');
    if (!preloader) return;

    preloader.classList.remove('flying', 'hiding', 'removed');
    document.body.classList.remove('luxe-flying', 'luxe-header-visible');
    void preloader.offsetHeight;
    document.body.classList.add('luxe-loading');

    // Get the actual header logo element to match its position
    var preloaderLogo = preloader.querySelector('.luxe-preloader__logo');
    var headerLogo = document.querySelector('.arshe-header__logo');

    // Function to sync preloader logo with header logo position
    function syncLogoPosition() {
      if (!preloaderLogo || !headerLogo) return;

      // Temporarily show header to get its position
      var header = document.querySelector('.arshe-header');
      if (header) {
        var wasHidden = header.style.opacity;
        header.style.opacity = '0.001';
        header.style.visibility = 'visible';
        header.style.pointerEvents = 'none';

        // Get header logo's exact position
        var rect = headerLogo.getBoundingClientRect();
        var computedStyle = window.getComputedStyle(headerLogo);

        // Set CSS variables for the flying state
        preloader.style.setProperty('--land-top', rect.top + 'px');
        preloader.style.setProperty('--land-left', (rect.left + rect.width / 2) + 'px');
        preloader.style.setProperty('--land-font-size', computedStyle.fontSize);
        preloader.style.setProperty('--land-letter-spacing', computedStyle.letterSpacing);
        preloader.style.setProperty('--land-color', computedStyle.color);

        // Restore header
        header.style.opacity = wasHidden || '';
        header.style.visibility = '';
        header.style.pointerEvents = '';
      }
    }

    // Sync position on load and resize
    syncLogoPosition();
    window.addEventListener('resize', syncLogoPosition);

    // Step 1: Fly at 1.15s
    setTimeout(function() {
      syncLogoPosition(); // Sync again right before flying
      preloader.classList.add('flying');
      document.body.classList.add('luxe-flying');
    }, 1150);

    // Step 2: Hide preloader + show header at 1.85s
    setTimeout(function() {
      preloader.classList.add('hiding');
      document.body.classList.remove('luxe-loading', 'luxe-flying');
      document.body.classList.add('luxe-header-visible');
    }, 1850);

    // Step 3: Remove at 2.35s
    setTimeout(function() {
      preloader.classList.add('removed');
    }, 2350);
  }

  // ═══ HEADER SCROLL ═══
  function initHeaderScroll() {
    var header = document.querySelector('.arshe-header');
    if (!header) return;
    var ticking = false;
    function update() {
      if (window.pageYOffset > 80) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
      ticking = false;
    }
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  }

  // ═══ SCROLL REVEAL ═══
  function initScrollReveal() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' });

    var elements = document.querySelectorAll('.reveal, .reveal-scale, .reveal-rotate, .reveal-blur, .luxe-story, .luxe-testimonial, .luxe-note-card, .luxe-instagram__item');

    elements.forEach(function(el, index) {
      if (el.classList.contains('luxe-testimonial') || el.classList.contains('luxe-note-card') || el.classList.contains('luxe-instagram__item')) {
        el.style.transitionDelay = (index % 6) * 0.1 + 's';
      }
      observer.observe(el);
    });
  }

  // ═══ MOUSE PARALLAX ═══
  function initMouseParallax() {
    var hero = document.querySelector('.luxe-hero');
    if (!hero) return;
    var content = hero.querySelector('.luxe-hero__content');
    if (!content) return;

    hero.addEventListener('mousemove', function(e) {
      var rect = hero.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      content.style.transform = 'perspective(1000px) rotateY(' + (x * 3) + 'deg) rotateX(' + (-y * 3) + 'deg) translateZ(0)';
    });

    hero.addEventListener('mouseleave', function() {
      content.style.transform = 'perspective(1000px) rotateY(0) rotateX(0) translateZ(0)';
    });
  }

  // ═══ SCROLL PARALLAX ═══
  function initScrollParallax() {
    var heroContent = document.querySelector('.luxe-hero__content');
    if (!heroContent) return;
    var ticking = false;

    function update() {
      var scrolled = window.pageYOffset;
      var winHeight = window.innerHeight;
      if (scrolled < winHeight) {
        var progress = scrolled / winHeight;
        heroContent.style.opacity = 1 - progress * 1.5;
        heroContent.style.transform = 'translateY(' + (scrolled * 0.4) + 'px)';
      }
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  }

  // ═══ PRODUCT MODAL ═══
  function initProductModal() {
    var overlay = document.querySelector('.luxe-modal-overlay');
    if (!overlay) return;

    var closeBtn = overlay.querySelector('.luxe-modal__close');

    document.querySelectorAll('[data-product-modal]').forEach(function(product) {
      product.addEventListener('click', function(e) {
        e.preventDefault();
        openModal(product);
      });
    });

    function closeModal() {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeModal();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('active')) closeModal();
    });

    function openModal(product) {
      setText('luxeModalNumber', product.getAttribute('data-number') || '');
      setText('luxeModalTitle', product.getAttribute('data-name') || '');
      setText('luxeModalCategory', product.getAttribute('data-category') || '');
      setText('luxeModalDescription', product.getAttribute('data-description') || '');
      setText('luxeModalNoteTop', product.getAttribute('data-note-top') || '');
      setText('luxeModalNoteHeart', product.getAttribute('data-note-heart') || '');
      setText('luxeModalNoteBase', product.getAttribute('data-note-base') || '');
      setText('luxeModalSize', product.getAttribute('data-size') || '50ml');
      setText('luxeModalConcentration', product.getAttribute('data-concentration') || 'EDP');
      setText('luxeModalPrice', product.getAttribute('data-price') || '');

      var buyBtn = document.getElementById('luxeModalBuyBtn');
      if (buyBtn) buyBtn.setAttribute('href', product.getAttribute('data-url') || '#');

      var imageContainer = document.getElementById('luxeModalImage');
      var image = product.getAttribute('data-image') || '';
      var name = product.getAttribute('data-name') || '';
      if (imageContainer) {
        if (image && image.length > 0) {
          imageContainer.innerHTML = '<img src="' + image + '" alt="' + name + '">';
        } else {
          imageContainer.innerHTML = '<div class="luxe-modal__image-placeholder">' + name + '</div>';
        }
      }

      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function setText(id, text) {
      var el = document.getElementById(id);
      if (el) el.textContent = text;
    }
  }

  // ═══ QUIZ ═══
  function initQuiz() {
    var quiz = document.querySelector('.luxe-quiz');
    if (!quiz) return;

    var questions = quiz.querySelectorAll('.luxe-quiz__question');
    var progressDots = quiz.querySelectorAll('.luxe-quiz__progress-dot');
    var result = quiz.querySelector('.luxe-quiz__result');
    var resultName = document.getElementById('luxeQuizResultName');
    var resultDesc = document.getElementById('luxeQuizResultDesc');
    var restartBtn = quiz.querySelector('[data-quiz-restart]');

    if (!questions.length) return;

    var currentQuestion = 0;
    var scores = {};

    var fragrances = {
      'icy-wave': { name: 'Icy Wave', desc: 'A refreshing burst of arctic freshness.' },
      'flora': { name: 'Flora', desc: 'A romantic bouquet in a bottle.' },
      '90s-love': { name: "90's Love", desc: 'Nostalgic sweetness meets modern confidence.' },
      'oud-wood': { name: 'Oud Wood', desc: 'An ancient ritual, bottled.' },
      'caramel-oud': { name: 'Caramel Oud', desc: 'Sweet indulgence meets exotic mystery.' },
      '19-11': { name: '19/11', desc: 'A modern statement of confidence.' },
      'juicy-bloom': { name: 'Juicy Bloom', desc: 'A vibrant celebration of fruit and flower.' }
    };

    quiz.querySelectorAll('.luxe-quiz__option').forEach(function(option) {
      option.addEventListener('click', function() {
        var value = this.getAttribute('data-value');
        if (!value) return;
        scores[value] = (scores[value] || 0) + 1;
        currentQuestion++;
        if (currentQuestion < questions.length) showQuestion(currentQuestion);
        else showResult();
      });
    });

    if (restartBtn) {
      restartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        currentQuestion = 0;
        scores = {};
        if (result) result.classList.remove('active');
        showQuestion(0);
      });
    }

    function showQuestion(index) {
      questions.forEach(function(q, i) { q.classList.toggle('active', i === index); });
      progressDots.forEach(function(dot, i) { dot.classList.toggle('active', i <= index); });
    }

    function showResult() {
      var topFragrance = 'caramel-oud';
      var maxScore = 0;
      for (var key in scores) {
        if (scores[key] > maxScore) {
          maxScore = scores[key];
          topFragrance = key;
        }
      }
      var frag = fragrances[topFragrance] || fragrances['caramel-oud'];
      if (resultName) resultName.textContent = frag.name;
      if (resultDesc) resultDesc.textContent = frag.desc;
      questions.forEach(function(q) { q.classList.remove('active'); });
      progressDots.forEach(function(dot) { dot.classList.add('active'); });
      if (result) result.classList.add('active');
    }

    showQuestion(0);
  }

  // ═══ MOBILE CART ═══
  function initMobileCart() {
    var cart = document.querySelector('.luxe-mobile-cart');
    if (!cart) return;
    var ticking = false;
    function update() {
      if (window.pageYOffset > window.innerHeight * 0.8) cart.classList.add('visible');
      else cart.classList.remove('visible');
      ticking = false;
    }
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  }

  // ═══ SMOOTH SCROLL ═══
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        var href = this.getAttribute('href');
        if (href === '#') return;
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          window.scrollTo({ top: target.offsetTop - 80, behavior: 'smooth' });
        }
      });
    });
  }

  // ═══ PARTICLE INTERACTION ═══
  function initParticleInteraction() {
    var bg = document.querySelector('.luxe-bg');
    if (!bg) return;
    var ticking = false;
    var mouseX = 0, mouseY = 0;
    document.addEventListener('mousemove', function(e) {
      mouseX = (e.clientX / window.innerWidth - 0.5) * 20;
      mouseY = (e.clientY / window.innerHeight - 0.5) * 20;
      if (!ticking) {
        window.requestAnimationFrame(function() {
          bg.style.transform = 'translate(' + mouseX + 'px, ' + mouseY + 'px)';
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // ═══ ARSHÉ PRODUCT CAROUSEL — MOBILE FIRST / TOUCH FIRST ═══
  function initCarousel() {
    if (window.__ARSHE_V11_NATIVE_CAROUSEL__) return;
    var carousel = document.querySelector('[data-arshe-carousel]');
    if (!carousel) return;
    var track = carousel.querySelector('[data-carousel-track]');
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-carousel-slide]'));
    var section = carousel.closest('.arshe-collection-v2') || document;
    var prevBtn = section.querySelector('[data-carousel-prev]');
    var nextBtn = section.querySelector('[data-carousel-next]');
    var dotsContainer = section.querySelector('[data-carousel-dots]');
    var sizeTabs = section.querySelectorAll('[data-size-tab]');
    if (!track || !slides.length) return;

    var currentIndex = 0;
    var raf;

    function centerSlide(index, behavior) {
      currentIndex = Math.max(0, Math.min(index, slides.length - 1));
      var slide = slides[currentIndex];
      if (!slide) return;
      var target = slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2;
      track.scrollTo({ left: Math.max(0, target), behavior: behavior || 'smooth' });
      updateDots();
    }

    function updateDots() {
      if (!dotsContainer) return;
      dotsContainer.querySelectorAll('button').forEach(function(dot, i) {
        dot.classList.toggle('active', i === currentIndex);
      });
    }

    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      slides.forEach(function(_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'luxe-carousel__dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'View fragrance ' + (i + 1));
        dot.addEventListener('click', function() { centerSlide(i); });
        dotsContainer.appendChild(dot);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { centerSlide(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { centerSlide(currentIndex + 1); });

    track.addEventListener('scroll', function() {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function() {
        var center = track.scrollLeft + track.clientWidth / 2;
        var closest = 0, distance = Infinity;
        slides.forEach(function(slide, i) {
          var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          var d = Math.abs(slideCenter - center);
          if (d < distance) { distance = d; closest = i; }
          var ratio = Math.min(1, d / Math.max(1, slide.offsetWidth * 1.15));
          slide.style.setProperty('--arshe-depth', (1 - ratio).toFixed(3));
          slide.classList.toggle('is-near-center', d < slide.offsetWidth * .68);
        });
        currentIndex = closest;
        updateDots();
      });
    }, { passive: true });

    /* Touch devices: let the browser handle native momentum scrolling.
       The old pointermove implementation fought the browser's compositor
       and caused the center card to feel laggy. Mouse dragging is retained. */
    var dragging = false, moved = false, startX = 0, scrollStart = 0;
    track.addEventListener('pointerdown', function(e) {
      if (e.pointerType !== 'mouse') return;
      if (e.button !== 0) return;
      dragging = true;
      moved = false;
      startX = e.clientX;
      scrollStart = track.scrollLeft;
      track.classList.add('is-dragging');
      if (track.setPointerCapture) track.setPointerCapture(e.pointerId);
    });
    track.addEventListener('pointermove', function(e) {
      if (!dragging) return;
      var delta = e.clientX - startX;
      if (Math.abs(delta) > 5) moved = true;
      track.scrollLeft = scrollStart - delta;
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      if (moved) centerSlide(currentIndex, 'smooth');
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('lostpointercapture', endDrag);

    /* After a native touch swipe settles, softly align the nearest card.
       Debouncing prevents repeated animation calls during a swipe. */
    var settleTimer = 0;
    track.addEventListener('scroll', function() {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var center = track.scrollLeft + track.clientWidth / 2;
        var closest = 0, distance = Infinity;
        slides.forEach(function(slide, i) {
          var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          var d = Math.abs(slideCenter - center);
          if (d < distance) { distance = d; closest = i; }
        });
        currentIndex = closest;
        var slide = slides[closest];
        if (!slide) return;
        var target = slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2;
        if (Math.abs(track.scrollLeft - target) > 2) {
          track.scrollTo({left: Math.max(0, target), behavior:'smooth'});
        }
      }, 110);
    }, {passive:true});

    track.addEventListener('click', function(e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);

    function setSize(size, source) {
      if (source && source.closest('.arshe-product-card')) {
        updateCard(source.closest('.arshe-product-card'), size);
      } else {
        slides.forEach(function(slide) { updateCard(slide, size); });
      }
      sizeTabs.forEach(function(tab) {
        var active = tab.getAttribute('data-size-tab') === size;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function updateCard(card, size) {
      var price = card.querySelector('.arshe-product-card__price');
      var link = card.querySelector('.arshe-product-card__link');
      var mediaLink = card.querySelector('.arshe-product-card__media');
      var id = card.getAttribute('data-v' + size.replace('ml','') + '-id');
      var priceValue = card.getAttribute('data-v' + size.replace('ml','') + '-price');
      var url = card.getAttribute('data-v' + size.replace('ml','') + '-url');
      var available = !!id && !!url;
      if (price) price.textContent = priceValue || '—';
      if (link) link.href = url || card.getAttribute('data-product-url') || '#';
      if (mediaLink) mediaLink.href = url || card.getAttribute('data-product-url') || '#';
      card.querySelectorAll('[data-size-choice]').forEach(function(btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-size-choice') === size);
        btn.setAttribute('aria-pressed', btn.getAttribute('data-size-choice') === size ? 'true' : 'false');
        btn.disabled = !card.getAttribute('data-v' + btn.getAttribute('data-size-choice').replace('ml','') + '-id');
      });
      card.classList.toggle('is-unavailable-size', !available);
    }

    sizeTabs.forEach(function(tab) { tab.addEventListener('click', function() { setSize(tab.getAttribute('data-size-tab'), null); }); });
    section.querySelectorAll('[data-size-choice]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        setSize(btn.getAttribute('data-size-choice'), btn);
      });
    });

    setSize('30ml', null);
    requestAnimationFrame(function() { centerSlide(0, 'auto'); });
  }

  // ═══ DISCOVERY ═══
  function initDiscovery() {
    var section = document.querySelector('.luxe-discovery');
    if (!section) return;

    var scene = section.querySelector('.luxe-discovery__scene');
    if (!scene) return;

    var isMobile = window.innerWidth < 900;

    if (!isMobile) {
      section.addEventListener('mousemove', function(e) {
        var rect = section.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        scene.style.transform = 'perspective(1500px) rotateY(' + (x * 15) + 'deg) rotateX(' + (-y * 10) + 'deg)';
      });

      section.addEventListener('mouseleave', function() {
        scene.style.transform = 'perspective(1500px) rotateY(0) rotateX(0)';
      });
    }

    var priceEl = section.querySelector('.luxe-discovery__price-new');
    if (priceEl) {
      var priceObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            animatePrice(priceEl);
            priceObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.5 });
      priceObserver.observe(priceEl);
    }

    function animatePrice(el) {
      var target = parseInt(el.getAttribute('data-price') || '499', 10);
      var start = parseInt(el.getAttribute('data-price-start') || '999', 10);
      var duration = 1200;
      var startTime = null;

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        var current = Math.floor(start - (start - target) * easeOutCubic(progress));
        el.textContent = '₹' + current;
        if (progress < 1) window.requestAnimationFrame(step);
      }

      function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }
      window.requestAnimationFrame(step);
    }
  }

  // ═══ INIT ═══
  function init() {
    // ARSHE V6 preloader is handled by arshe-final-polish.js
    initHeaderScroll();
    initScrollReveal();
    initMouseParallax();
    initScrollParallax();
    initProductModal();
    initQuiz();
    initMobileCart();
    initSmoothScroll();
    initParticleInteraction();
    // ARSHÉ carousel is intentionally owned by arshe-final-polish.js.
    // Keeping the legacy initializer disabled prevents two scroll controllers
    // from fighting each other on touch devices.
    initDiscovery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

/* ═══════════════════════════════════════════════
   🎬 CINEMATIC SCROLL ANIMATIONS ENGINE
   ═══════════════════════════════════════════════ */

(function() {
  'use strict';

  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {

    /* ─── 1. SCROLL PROGRESS BAR ─── */
    const progressBar = document.createElement('div');
    progressBar.className = 'arshe-scroll-progress';
    progressBar.innerHTML = '<div class="arshe-scroll-progress__bar"></div>';
    document.body.appendChild(progressBar);

    const progressBarFill = progressBar.querySelector('.arshe-scroll-progress__bar');

    function updateScrollProgress() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (scrollTop / scrollHeight) * 100;
      progressBarFill.style.width = progress + '%';
    }

    /* ─── 2. INTERSECTION OBSERVER FOR REVEAL ANIMATIONS ─── */
    const observerOptions = {
      threshold: 0.15,
      rootMargin: '0px 0px -80px 0px'
    };

    const scrollObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          // Once revealed, stop observing (better performance)
          scrollObserver.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe ALL animate-able elements
    const animateElements = document.querySelectorAll(`
      [data-scroll],
      .arshe-hero__content,
      .arshe-hero__visual,
      .arshe-benefits__header,
      .arshe-benefits__card,
      .arshe-discovery__visual,
      .arshe-discovery__content,
      .arshe-ritual__header,
      .arshe-ritual__step,
      .arshe-ritual__cta-wrap,
      .luxe-carousel-header,
      .luxe-carousel,
      .luxe-campaign__visual,
      .luxe-campaign__content,
      .luxe-notes__container > *,
      .luxe-note-card,
      .luxe-quiz__container > *,
      .luxe-testimonials__container > *,
      .luxe-testimonial,
      .luxe-instagram__container > *,
      .luxe-instagram__item
    `);

    animateElements.forEach(function(el) {
      scrollObserver.observe(el);
    });

    /* ─── 3. PARALLAX IMAGE EFFECTS ─── */
    const parallaxImages = document.querySelectorAll(
      '.arshe-hero__image, .arshe-discovery__image'
    );

    function updateParallax() {
      const scrollTop = window.pageYOffset;

      parallaxImages.forEach(function(img) {
        const rect = img.getBoundingClientRect();
        const centerY = rect.top + rect.height / 2;
        const windowCenter = window.innerHeight / 2;
        const distance = (centerY - windowCenter) * 0.05;

        // Only apply if in view
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          img.style.transform = 'translate3d(0, ' + distance + 'px, 0) scale(1.02)';
        }
      });
    }

    /* ─── 4. SMOOTH SCROLL FOR ANCHOR LINKS ─── */
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          const offsetTop = target.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
      });
    });

    /* ─── 5. THROTTLED SCROLL HANDLER ─── */
    let scrollTicking = false;

    function handleScroll() {
      if (!scrollTicking) {
        window.requestAnimationFrame(function() {
          updateScrollProgress();
          updateParallax();
          scrollTicking = false;
        });
        scrollTicking = true;
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true });

    // Initial call
    updateScrollProgress();

    /* ─── 6. HERO ENTRANCE ANIMATION ─── */
    setTimeout(function() {
      const heroContent = document.querySelector('.arshe-hero__content');
      const heroVisual = document.querySelector('.arshe-hero__visual');
      if (heroContent) heroContent.classList.add('in-view');
      if (heroVisual) heroVisual.classList.add('in-view');
    }, 300);

  });

})();